import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MainService } from 'src/app/services/main/main.service';
import { ProfileDialogComponent } from 'src/app/shared/profile-dialog/profile-dialog.component';

@Component({
  selector: 'app-accountdetail',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.scss'],
})
export class AccountdetailComponent implements OnInit {
  getProfileData: any;
  modalDetails: any = {};
  photoIdEvidenceFront: any;
  photoIdEvidenceBack: any;
  sliceRouting: any;
  constructor(
    public mainService: MainService,
    public dialog: MatDialog,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.getBankInfo();
    this.sliceRouting = String(this.getProfileData.bank_details.routing_number).slice(-4);
    this.modalDetails = {
      ssn: this.getProfileData && this.getProfileData.profile && this.getProfileData.profile[0] && this.getProfileData.profile[0].tin && this.getProfileData.profile[0].tin.toString().replace(/\S{5}/, "*****") || '*********',
    };
  }

  getBankInfo() {
    this.getProfileData = this.authService.getProfileData;
  }

  uploadImages() {
    let formdata = new FormData();
    let token = localStorage.getItem('token');
    formdata.append('access_token', token);
    formdata.append('dl_front', this.photoIdEvidenceFront);
    if (this.photoIdEvidenceBack !== undefined) {
      formdata.append('dl_back', this.photoIdEvidenceBack);
    }
    this.mainService
      .uploadApi(formdata, 'upload_doctor_document', true)
      .subscribe(async (data: any) => {
        if (data && data.is_error == 0) {
          this.authService.getbankDetails();
          setTimeout(() => {
            this.getBankInfo();
          }, 2000);
        }
      });
  }

  uploadPhotoId(event, type) {
    if (event && event.target && event.target.files && event.target.files[0] && event.target.files[0].type.includes('image')) {
      if (type == 'F') {
        this.photoIdEvidenceFront = event.target.files[0];
        return;
      }
      else {
        this.photoIdEvidenceBack = event.target.files[0];
      }
    }
    else {
      this.mainService.customPopups('Please upload a valid image', 1)
    }
  }
  OtherAccountInformation() {
    let tillaDialogRef = this.dialog.open(ProfileDialogComponent, {
      width: '750px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 55,
        title: 'Account Information',
        values: this.modalDetails,
      },
    });
  }
}